import { bindEvents, getPseudoProperty, offset } from '../../assets/js/helpers';

import AnimationController from '../../assets/js/controller/animation';
import OverlayController from '../../assets/js/controller/overlay';
import SectionController from '../../assets/js/controller/section';


const selector = 'image-feed';

export default class ImageFeed {

	constructor(section) {
		this.el = {
			section,
			galleries: section.querySelectorAll(`.${selector}__gallery`),
			lists: section.querySelectorAll('ul'),
			items: section.querySelectorAll('li'),
			headlines: document.querySelectorAll('.image-feed-headline li')
		};

		this.columnCount = 0;
		this.columnWidth = 0;

		this.active = null;

		this.animation = null;

		this.events = bindEvents(this);

		this.addEventListeners();
		this.getColumnCount();
		this.getColumnWidth();
		this.arrangeLists();
		this.start();
	}

	static get selector() {
		return selector;
	}

	getColumnCount() {
		this.columnCount = parseInt(getPseudoProperty(this.el.section, 'content'), 10);
	}

	getColumnWidth() {
		this.columnWidth = Math.round(this.el.galleries[0].clientWidth / this.columnCount);
	}

	arrangeLists() {
		for (const list of this.el.lists) {
			this.positionItems(list);
		}
	}

	positionItems(list) {
		const items = list.querySelectorAll('li');
		const columnHeight = new Array(this.columnCount).fill(0);
		for (const item of items) {
			const column = columnHeight.indexOf(Math.min(...columnHeight));
			item.style.left = `${column * this.columnWidth}px`;
			item.style.top = `${columnHeight[column]}px`;
			columnHeight[column] += item.offsetHeight;
		}
		list.style.height = `${Math.max(...columnHeight)}px`;
	}

	update(position) {
		let active = 0;
		for (let i = 0, l = this.el.galleries.length; i < l; ++i) {
			if (position.current + window.innerHeight / 2 > offset.top(this.el.galleries[i])) {
				active = i;
			}
		}
		if (active !== this.active) {
			this.active = active;
			return true;
		}
	}

	render() {
		for (let i = 0, l = this.el.headlines.length; i < l; ++i) {
			this.el.headlines[i].classList[i === this.active ? 'add' : 'remove']('is-active');
		}
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'image feed');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	_onWindowLoad() {
		this.getColumnCount();
		this.getColumnWidth();
		this.arrangeLists();
	}

	_onWindowResize() {
		this.getColumnCount();
		this.getColumnWidth();
		this.arrangeLists();
	}

	_onItemClick(e) {
		e.preventDefault();
		OverlayController.open('gallery');
		SectionController.globals.gallery.show(e.currentTarget.querySelector('img').dataset.src);
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);

		for (const item of this.el.items) item.addEventListener('click', this.events._onItemClick);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);

		for (const item of this.el.items) item.removeEventListener('click', this.events._onItemClick);
	}

	destroy() {
		this.pause();
		this.removeEventListeners();
	}

}
